import clsx from "clsx";
import type { HTMLAttributes, ReactNode } from "react";

/**
 * A white panel (redesign spec §6): border, 12px radius, 20px padding, its parts 12px apart.
 * Give it an `aria-label` to make it a named region.
 */
export function Panel({
  title,
  action,
  className,
  children,
  ...props
}: Omit<HTMLAttributes<HTMLElement>, "title"> & { title?: ReactNode; action?: ReactNode }) {
  return (
    <section
      {...props}
      className={clsx("flex min-w-0 flex-col gap-3 rounded-xl border border-line bg-surface p-5", className)}
    >
      {title || action ? (
        <div className="flex flex-wrap items-center gap-2">
          {title ? <h2 className="text-lg font-semibold text-ink">{title}</h2> : null}
          {action ? <div className="ml-auto flex items-center gap-3">{action}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
